import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6e90f802")

_pushScopeId("data-v-6e90f802")
const _hoisted_1 = { class: "flex-center margin-top-10" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("预览 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("保存 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("取消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_cascader = _resolveComponent("el-cascader")
  const _component_tag_input = _resolveComponent("tag-input")
  const _component_el_input_number = _resolveComponent("el-input-number")
  const _component_el_form = _resolveComponent("el-form")
  const _component_card_set_detail = _resolveComponent("card-set-detail")
  const _component_el_button = _resolveComponent("el-button")
  const _component_card_set_preview = _resolveComponent("card-set-preview")
  const _component_el_drawer = _resolveComponent("el-drawer")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      ref: "form",
      model: _ctx.formData,
      "label-width": "80px"
    }, {
      default: _withId(() => [
        _createVNode(_component_el_form_item, {
          prop: "name",
          rules: [{ required: true,message: '请输入名称',trigger: 'blur' }],
          label: "名称"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.formData.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.name = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          prop: "categoryIds",
          rules: [{ required: true,message: '请输入分类' ,trigger: 'blur' }],
          label: "分类"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_cascader, {
              modelValue: _ctx.formData.categoryIds,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.categoryIds = $event)),
              options: _ctx.cardSetCategoryStore.cardSetCategories,
              props: {value: 'id', label: 'name', checkStrictly: true}
            }, null, 8, ["modelValue", "options"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          prop: "tags",
          label: "标签"
        }, {
          default: _withId(() => [
            _createVNode(_component_tag_input, {
              allowAddNewTag: false,
              modelValue: _ctx.formData.tags,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.tags = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          prop: "description",
          label: "说明"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.formData.description,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.description = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          prop: "cardCount",
          rules: [{ required: true,message: '请输入张数',trigger: 'blur' }],
          label: "张数"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_input_number, {
              size: "mini",
              modelValue: _ctx.formData.cardCount,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.cardCount = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_card_set_detail, {
      "error-tag-ids": _ctx.errorTagIds,
      "card-set-id": _ctx.cardSet.id,
      "is-editing": true,
      modelValue: _ctx.parts,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.parts = $event)),
      cardCount: _ctx.formData.cardCount
    }, null, 8, ["error-tag-ids", "card-set-id", "modelValue", "cardCount"]),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_el_button, {
        class: "margin-right-10",
        type: "primary",
        onClick: _ctx.openPreview
      }, {
        default: _withId(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_el_button, {
        class: "margin-right-10",
        type: "primary",
        onClick: _ctx.onSubmit
      }, {
        default: _withId(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_el_button, { onClick: _ctx.cancel }, {
        default: _withId(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_el_drawer, {
      title: "预览",
      direction: "ltr",
      modelValue: _ctx.previewDialogVisible,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.previewDialogVisible = $event)),
      size: "60%"
    }, {
      default: _withId(() => [
        _createVNode(_component_card_set_preview, {
          "card-set-id": _ctx.cardSet.id,
          "card-set-parts": _ctx.parts
        }, null, 8, ["card-set-id", "card-set-parts"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
})